const SITE_URL = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://itaobuyspread.sbs';
const SITE_NAME = 'Itaobuy Spreadsheet Italia';
const SITE_DESCRIPTION = 'La guida italiana definitiva per lo shopping internazionale. Database prodotti, guide esperte e analisi indipendenti.';
const LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg';

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: LOGO_URL,
    description: SITE_DESCRIPTION,
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_DESCRIPTION,
    inLanguage: 'it-IT',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageSchema(pageUrl: string, pageName: string, pageDescription: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: pageName,
    url: `${SITE_URL}${pageUrl}`,
    description: pageDescription,
    inLanguage: 'it-IT',
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
      logo: LOGO_URL,
    },
  };
}

export function getArticleSchema(
  pageUrl: string,
  headline: string,
  description: string,
  datePublished: string,
  dateModified: string,
  authorName: string,
  imageUrl?: string,
  timeRequired?: string,
) {
  const article: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    url: `${SITE_URL}${pageUrl}`,
    datePublished,
    dateModified,
    inLanguage: 'it-IT',
    author: {
      '@type': 'Person',
      name: authorName,
      description: 'Analista esperto del mercato internazionale con oltre 5 anni di esperienza nello shopping cross-border.',
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: LOGO_URL,
      },
    },
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}${pageUrl}`,
    },
  };
  if (imageUrl) {
    article.image = imageUrl;
  }
  if (timeRequired) {
    article.timeRequired = timeRequired;
  }
  return article;
}

export function getBreadcrumbSchema(items: Array<{ name: string; url: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url.startsWith('http') ? item.url : `${SITE_URL}${item.url}`,
    })),
  };
}

export function getFAQSchema(questions: Array<{ q: string; a: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };
}

export { SITE_URL, SITE_NAME, LOGO_URL };